<template>
  <div class="pre-fundDetailForm-container blue-avue-form">
    <InfoContainer :infoTitle="InfoContainerConfig['infoTitle']" :contentConfig="InfoContainerConfig['infoContent']"
      class="comment-container">
      <template slot="basicInfo">
        <avue-form ref="form" v-model="addFormInfo" :option="addFormConfig" @submit="submitForm" :loading="loading">
          <template slot="masterName">
            <SelectInput bindLabel="name" :allowCreate="false" :disabled="disabled||!subFundsAdd" searchKey="dictValue"
              bindKey="id" methods="get" dataMethod="params" :initParam="{auditState: 2,bizType:2}" dataUrl="fund/master/page" @handleChange="(el) => changeMasterId(el)"
              :bindId="addFormInfo['masterId'] ? addFormInfo['masterId'] : ''" />
          </template>
          <template slot="investDate">
            <div class="form_slot">
              <el-date-picker v-model="addFormInfo.fundInvestDateBegin" type="date" format="yyyy-MM-dd"
                valueFormat="yyyy-MM-dd" placeholder="开始数值" />
              ~
              <el-date-picker v-model="addFormInfo.fundInvestDateEnd" type="date" format="yyyy-MM-dd"
                valueFormat="yyyy-MM-dd" placeholder="结束数值" />
            </div>
          </template>
          <template slot="quitDate">
            <div class="form_slot">
              <el-date-picker v-model="addFormInfo.fundQuitDateBegin" type="date" format="yyyy-MM-dd"
                valueFormat="yyyy-MM-dd" placeholder="开始数值" />
              ~
              <el-date-picker v-model="addFormInfo.fundQuitDateEnd" type="date" format="yyyy-MM-dd"
                valueFormat="yyyy-MM-dd" placeholder="结束数值" />
            </div>
          </template>
          <template slot="clearingDate">
            <div class="form_slot">
              <el-date-picker v-model="addFormInfo.fundClearingDateBegin" type="date" format="yyyy-MM-dd"
                valueFormat="yyyy-MM-dd" placeholder="开始数值" />
              ~
              <el-date-picker v-model="addFormInfo.fundClearingDateEnd" type="date" format="yyyy-MM-dd"
                valueFormat="yyyy-MM-dd" placeholder="结束数值" />
            </div>
          </template>

          <template slot="address">
            <el-cascader :disabled="disabled" :options="options" v-model="addFormInfo.address">
            </el-cascader>
          </template>
          <template #fdManagerName>
            <el-input v-if="disabled||!subFundsAdd" v-model="addFormInfo.fdManagerName" placeholder="请输入基金管理人"
              :disabled="true"></el-input>
            <div class="add-fund-manager" v-else>
              <SelectInput bindLabel="name" bindKey="id" bindValue="name" dataUrl="fund/manager/page" methods="get"
                dataMethod="params" searchKey="name" :bindId="
                  addFormInfo.managerId ? addFormInfo.managerId : ''
                " @handleChange="setManagerInfo" />
              <div class="add-button el-icon-plus" @click="showAddFundManager">
                添加
              </div>
            </div>
          </template>
        </avue-form>
      </template>
      <template slot="tableInfo" v-if="notSubFundsAdd()">
        <div class="table_info">
          <!-- <div class="table_info_border" style="margin-top: 40px"></div> -->
          <div class="header-left">
            <span class="box-header-title">基金管理人和基金托管人</span>

          </div>
          <table align="center" style="margin: auto" class="table_wrapper" border="1px" cellpadding="5px;"
            cellspacing="0" borderColor="#e0eeff">
            <th colspan="2" class="header_cell">项目</th>
            <th class="header_cell">基金管理人</th>
            <th class="header_cell">基金托管人</th>
            <tr>
              <td colspan="2" class="header_cell">名称</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['name']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["name"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['name']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["name"]
                }}</template>
              </td>
            </tr>
            <tr>
              <td rowspan="3" class="first_td header_cell">信息披露联系人</td>
              <td class="first_td header_cell">姓名</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['contacterName']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["contacterName"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['contacterName']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["contacterName"]
                }}</template>
              </td>
            </tr>

            <tr>
              <td class="first_td header_cell">联系电话</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['contacterPhone']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["contacterPhone"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['contacterPhone']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["contacterPhone"]
                }}</template>
              </td>
            </tr>
            <tr>
              <td class="first_td header_cell">电子邮箱</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['contacterEmail']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["contacterEmail"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['contacterEmail']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["contacterEmail"]
                }}</template>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="header_cell">传真</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['fax']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["fax"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['fax']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["fax"]
                }}</template>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="header_cell">注册地址</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['registerAddress']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["registerAddress"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['registerAddress']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["registerAddress"]
                }}</template>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="header_cell">办公地址</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['businessAddress']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["businessAddress"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['businessAddress']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["businessAddress"]
                }}</template>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="header_cell">邮政编码</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['postCode']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["postCode"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['postCode']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["postCode"]
                }}</template>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="header_cell">法定代表人</td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicManager']['legalPerson']"></el-input>
                <template v-else>{{
                  addFormInfo["basicManager"]["legalPerson"]
                }}</template>
              </td>
              <td>
                <el-input v-if="!disabled" v-model="addFormInfo['basicTrustee']['legalPerson']"></el-input>
                <template v-else>{{
                  addFormInfo["basicTrustee"]["legalPerson"]
                }}</template>
              </td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="investor" v-if="notSubFundsAdd()">
        <div class="investor_wrapper">
          <!-- <div class="table_info_border" style="margin-top: 40px"></div> -->
          <div class="header-left">
            <span class="box-header-title">投资者情况</span>

          </div>

          <div class="investor_list" v-for="(item, index) in addFormInfo.basicInvestors" :key="index">
            <div class="close_btn" v-if="index > 0 && !disabled" @click="delBasicInvestors(index)">
              <div class="text">×</div>
            </div>
            <div class="index_number">
              <div class="text">{{ index + 1 }}</div>
            </div>
            <el-form ref="investorForm" :model="item" label-width="120px">
              <el-row :gutter="20">
                <el-col :span="11">
                  <!-- <el-form-item label="公司名称">
                    <el-input v-model="item.companyName" placeholder="请输入" :disabled="disabled"></el-input>
                  </el-form-item> -->
                  <el-form-item label="合伙人类别">
                    <el-input v-model="item.partnerType" placeholder="请输入" :disabled="disabled"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="11">
                  <el-form-item label="公司名称">
                    <el-input v-model="item.companyName" placeholder="请输入" :disabled="disabled"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="社会信用代码">
                    <el-input v-model="item.socialCreditCode" placeholder="请输入" :disabled="disabled"></el-input>
                  </el-form-item>
                </el-col>                
                <el-col :span="11">
                  <el-form-item label="合伙人性质">
                    <el-input v-model="item.partnerNature" placeholder="请输入" :disabled="disabled"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="认缴金额">
                    <el-input-number v-model="item.capitalSubscribed" placeholder="请输入" :controls="false"
                      :disabled="disabled"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="认缴比例">
                    <el-input v-model="item.capitalSubscribedRatio" placeholder="请输入" :disabled="disabled">
                      <template slot="append"> % </template>
                    </el-input>
                  </el-form-item>
                </el-col>

                <!-- <div v-for="(el, index_) in item.capitals" :key="'el' + index_">
                  <el-col :span="11">
                    <el-form-item :label="'第' + toChinesNum(index_ + 1) + '期出资金额'">
                      <el-input-number v-model="el.capitalPaid" placeholder="请输入" :controls="false"
                        :disabled="disabled"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item :label="'第' + toChinesNum(index_ + 1) + '期出资时间'">
                      <el-date-picker v-model="el.capitalDate" type="date" placeholder="选择日期" :disabled="disabled"
                        format="yyyy-MM-dd" valueFormat="yyyy-MM-dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <div class="change_qishu" v-if="index_ == 0 && !disabled" @click="addCapitals(index, index_)">
                      <i class="el-icon-circle-plus-outline"></i> 新增
                    </div>
                    <div class="change_qishu" v-if="index_ > 0 && !disabled" @click="delCapitals(index, index_)">
                      <i class="el-icon-remove-outline"></i> 删除
                    </div>
                  </el-col>
                </div> -->

                <!-- <el-col :span="11">
                  <el-form-item label="合计实缴金额">
                    <el-input-number v-model="item.totalCapitalPaid" placeholder="请输入" :controls="false"
                      :disabled="disabled"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="缴款进度">
                    <el-input v-model="item.paidProgress" placeholder="请输入" :disabled="disabled"></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :span="11">
                  <el-form-item label="实缴金额">
                    <el-input v-model="item.totalCapitalPaid" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="table_custom_add" v-if="index == 0 && !disabled">
                <el-button icon="el-icon-circle-plus-outline" @click="addBasicInvestors">添加</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </template>
    </InfoContainer>

    <SelectPerson ref="selectperson" :checkUserList="checkUserList" :isOnly="false" :clear="false"
      @setPeople="setPeople" />
    <AddFundManager ref="addFundManager" @addPersonForm="setManagerInfo" />
  </div>
</template>
<script>
  import InfoContainer from "@/components/infoContainer/fundInfoContainer";
  import {
    subFundAddConfig
  } from "../config";
  import AddFundManager from "@/components/fundComponent/addFundManager";

  import WordUpload from "@/components/wordUpload/wordUpload";

  import SelectInput from "@/components/commonSelect/selectInput";
  import {
    mapGetters
  } from "vuex";
  import SelectPerson from "@/components/SelectPersonnel/person";
  import CommonDetail from "@/components/commonDetail/commonDetail";
  import TableCustom from "@/components/tableCustom/tableCustom";
  import {
    regionData,
    TextToCode,
    CodeToText
  } from "element-china-area-data";
  import * as api from "@/api/fund/fundProject";

  export default {
    name: "fundDetailForm",
    data() {
      return {
        checkUserList: [],
        deptInfo: {},
        files: [],
        visitTime: "",
        addFormInfo: {
          basicManager: {},
          basicTrustee: {},
          basicInvestors: [{
            capitals: [{}],
          }, ],
        },
        addFormConfig: subFundAddConfig(
          this.changeThirdParty,

        ),

        InfoContainerConfig: {
          infoTitle: "基本信息",
          infoContent: [{
              title: "",
              prop: "basicInfo",
            },
            {
              title: "",
              prop: "tableInfo",
            },
            {
              title: "",
              prop: "investor",
            },
          ],
        },

        baFileMenuId: "",

        options: regionData,
        firstQuery: true,
        loading: false,
        dialogShow: false,
        // projectAddress: [],
      };
    },
    components: {
      SelectPerson,
      InfoContainer,
      WordUpload,
      CommonDetail,
      TableCustom,
      SelectInput,
      AddFundManager,
    },
    props: {
      id: {
        type: String,
        default: "",
      },
      isDetail: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      // 传入的详细数据
      bindData: {
        type: Object,
        default: () => {
          return {};
        },
      },
      //是否是服务端子基金的新增
      subFundsAdd: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      "addFormInfo.investDate1": {
        handler(val) {
          if (val) {
            this.addFormInfo.fundInvestDateBegin = val[0];
            this.addFormInfo.fundInvestDateEnd = val[1];
          }
        },
        immediate: true,
      },
      "addFormInfo.quitDate1": {
        handler(val) {
          if (val) {
            this.addFormInfo.fundQuitDateBegin = val[0];
            this.addFormInfo.fundQuitDateEnd = val[1];
          }
        },
        immediate: true,
      },
      "addFormInfo.clearingDate1": {
        handler(val) {
          if (val) {
            this.addFormInfo.fundClearingDateBegin = val[0];
            this.addFormInfo.fundClearingDateEnd = val[1];
          }
        },
        immediate: true,
      },
      disabled: {
        handler(val) {
          this.addFormConfig.column.filter((item, index) => {

            if (
              ![
                "name",
                "masterName",
                "isDirectional",
                "cooperateType",
                "peScale",
                "totalCapitalPaid",
                "fdManagerName",
                "manageCycle",
                "isThirdParty",
              ].includes(item.prop)
            ) {
              item.disabled = this.disabled;
            }

          });
        },
        deep: true,
        immediate: true,
      },
      subFundsAdd: {
        handler(val) {
          this.addFormConfig.column.filter((item, index) => {

            if (val) {
              // if(item.prop!='managerName'){
                item.disabled = false;
              // }
            } else {
              item.display = true;
            }
            if(this.disabled){
               item.disabled = true; 
            }
          })
        },
        deep: true,
        immediate: true
      },



      addFormInfo: {
        handler(val) {
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
        },
      },
      bindData: {
        handler(newData, oldData) {
          let addFormInfo = JSON.parse(JSON.stringify(newData));
          if (addFormInfo.fundInvestDateBegin) {
            addFormInfo.investDate1 = [
              addFormInfo.fundInvestDateBegin,
              addFormInfo.fundInvestDateEnd,
            ];
            addFormInfo.quitDate1 = [
              addFormInfo.fundQuitDateBegin,
              addFormInfo.fundQuitDateEnd,
            ];
            addFormInfo.clearingDate1 = [
              addFormInfo.fundClearingDateBegin,
              addFormInfo.fundClearingDateEnd,
            ];
          }
          this.addFormInfo = addFormInfo;
        },
      },
    },
    computed: {
      ...mapGetters(["userInfo"]),
      notSubFundsAdd() {
        return function () {
          return !(this.subFundsAdd);
        };
      },
    },
    mounted() {
      // 详细页不执行查询详情操作
      // this.addFormConfig.column.filter((item, index) => {
      //   if (!item.disabled) {
      //     item.disabled = this.disabled;
      //   }
      //   if (this.subFundsAdd) {
      //     item.disabled = false;
      //   }
      // });
      if (this.$route.params.id && this.$route.params.id != -1) {
        // 查询投放管理详细信息
        // this.queryDetailData()
        // if (this.isDetail) {
        //   this.InfoContainerConfig.infoTitle = "项目信息";
        // } else {
        //   this.InfoContainerConfig.infoTitle = "编辑基金项目";
        // }

        this.$forceUpdate();
      }
    },

    methods: {
      //第三方选聘
      changeThirdParty(val) {
        this.$emit('changeThirdParty', val)

      },
      showAddFundManager() {
        this.$refs.addFundManager.showblock();
      },
      setManagerInfo(data) {
        this.addFormInfo.fdManagerName = data.name;
        this.addFormInfo.managerId = data.id;
      },

      toChinesNum(num) {
        let changeNum = [
          "零",
          "一",
          "二",
          "三",
          "四",
          "五",
          "六",
          "七",
          "八",
          "九",
        ];
        let unit = ["", "十", "百", "千", "万"];
        num = parseInt(num);
        let getWan = (temp) => {
          let strArr = temp.toString().split("").reverse();
          let newNum = "";
          for (var i = 0; i < strArr.length; i++) {
            newNum =
              (i == 0 && strArr[i] == 0 ?
                "" :
                i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ?
                "" :
                changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
              newNum;
          }
          return newNum;
        };
        let overWan = Math.floor(num / 10000);
        let noWan = num % 10000;
        if (noWan.toString().length < 4) {
          noWan = "0" + noWan;
        }
        return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
      },

      addBasicInvestors() {
        let addFormInfo = this.addFormInfo;
        addFormInfo.basicInvestors.push({
          capitals: [{}],
        });
        this.addFormInfo = addFormInfo;
      },
      delBasicInvestors(index) {
        this.addFormInfo["basicInvestors"].splice(index, 1);
      },
      // 新增出资
      addCapitals(index) {
        let addFormInfo = this.addFormInfo;
        addFormInfo.basicInvestors[index].capitals.push({});
        this.addFormInfo = addFormInfo;
      },
      // 删除出资
      delCapitals(index, index_) {
        this.addFormInfo["basicInvestors"][index].capitals.splice(index_, 1);
        // this.$confirm("是否删除此条数据?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning",
        // }).then(() => {
        //   this.loading = true;
        //   this.tableData.splice(index, 1);
        //   this.$emit("handleDel", index);
        // });
      },

      //  保存
      async savePage(startProcess) {
        let that = this;
        if (startProcess) {
          this.$confirm("是否确定提交审核?", "操作确认", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              that.getValidForm(startProcess);
            })
            .catch((res) => {
              that.$message({
                type: "info",
                message: "已取消",
              });
            });
        } else {
          that.getValidForm(startProcess);
        }
      },

      async getValidForm(startProcess) {
        // let validRes = await this.validForm();

        // if (validRes) {
        this.submitForm(startProcess);
        // }
      },
      async submitForm(startProcess) {
        this.loading = true;
        this.addFormInfo.basicInvestors.map((item) => {
          delete item.id;
          item.capitals.map((el) => {
            delete el.id;
          });
        });
        let params = {
          ...this.addFormInfo,
          domicile: this.addFormInfo.address.join(","),
        };
        // let apiName="submitFdbasicinfo"
        // if(startProcess){
        //   apiName="auditSubmitFdbasicinfo"
        // }
        let res = await api.submitFdbasicinfo(params);
        this.loading = false;
        if (res.data.code == 200) {
          if (startProcess) {
            this.auditSubmit();
          } else {
            this.$emit("getDetail");
            this.$message({
              message: "保存成功",
              type: "success",
            });
          }
        }
      },
      //提交审批
      async auditSubmit() {
        let params = {
          id: this.addFormInfo.id,
        };
        let res = await api.auditSubmitFdbasicinfo(params);
        if (res.data.code == 200) {
          this.$emit("getDetail");
          this.$message({
            message: "提交审核成功",
            type: "success",
          });
        }
      },

      validForm() {
        let self = this;

        return new Promise((resolve, reject) => {
          self.$refs.form.validate((valid, done) => {
            if (valid) {
              done();
              resolve(true);
            }
          });
        });
      },
      changeMasterId(el) {
        if (el) {
          this.addFormInfo.masterId = el.id;
          this.addFormInfo.masterName = el.name;
          
          // this.addFormInfo.managerName=el.managerName
        }
      },
    },
  };

</script>
<style lang="scss" scoped>
.pre-fundDetailForm-container {
  margin-top: 10px;

  .button-container {
    text-align: center;
  }
}

.comment-container {
  margin-top: 0px;

  /deep/.detail-one {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /deep/.comment-container {
    margin-top: 0 !important;
  }
}

.travel_tips {
  margin-top: 10px;
}

.display_flex {
  display: flex;
  color: #ff9900;
  align-items: center;
}

.table_info {
  margin-top:20px;
}
.header-left{
    float: left;
    margin-bottom: 10px;
  }
  .box-header-title{
      color: rgb(51,51,51);
      font-weight: 400;
      font-size:16px;
      padding-left: 5px;
    }
.table_info_border {
  border: 1px dashed #afd1f8;
  width: 100%;
  margin-bottom: 40px;
}

.table_wrapper {
  text-align: center;
  width: 100%;
  margin: auto;

  th,
  td {
    height: 40px;
    line-height: 40px;
  }

  tr:nth-child(1) {
    width: 240px;
  }

  .first_td {
    width: 120px;
  }
}

.investor_wrapper {
  text-align: center;
  margin-top:20px;

  .investor_title {
    color: #333333;
    font-size: 18px;
    font-weight: 700;
    padding-bottom: 20px;
  }
}

/deep/ .el-input-number {
  width: 100%;
  text-align: left;
}

/deep/ .el-input__inner {
  text-align: left;
}

/deep/.el-date-editor.el-input {
  width: 100%;
}

.investor_list {
  // margin-top:20px;
  padding: 40px 20px;
  position: relative;

  /deep/.el-form-item {
    margin-bottom: 4px;
  }

  .close_btn {
    border-width: 0px;
    position: absolute;
    right: 8.44%;
    top: 0px;
    width: 24px;
    height: 24px;
    background: inherit;
    background-color: rgba(64, 158, 255, 1);
    border: none;
    border-radius: 50px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-weight: 300;
    font-style: normal;
    font-size: 18px;
    color: #ffffff;
    z-index: 2;
    cursor: pointer;

    .text {
      align-self: center;
      box-sizing: border-box;
      width: 100%;
    }
  }

  .index_number {
    border-width: 0px;
    position: absolute;
    left: 10px;
    top: 36px;
    min-width: 24px;
    height: 24px;
    background: inherit;
    background-color: rgba(64, 158, 255, 1);
    border: none;
    border-radius: 50px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-weight: 300;
    font-style: normal;
    font-size: 18px;
    color: #ffffff;
    z-index: 2;
    cursor: pointer;

    .text {
      align-self: center;
      box-sizing: border-box;
      width: 100%;
    }
  }
}

.qishu_wrapper {
  display: flex;
  align-items: center;
}

.change_qishu {
  // padding-left: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;

  i {
    padding-right: 4px;
  }
}

.table_custom_add {
  padding: 20px 0;
  text-align: center;

  /deep/ .el-button {
    width: 50%;
    color: #469eff;
    border: 1px dashed #469eff;
  }
}

.bottom-container {
  width: 100%;
  height: 70px;
  position: fixed;
  // z-index: 1000;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);

  .button-container {
    width: 93%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.add-fund-manager {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .add-button {
    cursor: pointer;
    width: 70px;
    margin-left: 15px;
    text-align: right;
    color: #409eff;
  }
}

.form_slot {
  display: flex;
}
.header_cell {
  background-color: #F6FAFF;
  font-weight: 400;

}
</style>
<style lang="scss">
.pre-fundDetailForm-container {
  .el-range-editor.is-disabled {
    background-color: #fff !important;

    input {
      background-color: #fff !important;
      color: #606266;
    }
  }

  .is-disabled {
    .el-input__inner,
    .el-range-editor,
    .el-textarea__inner {
      background-color: #fff !important;
    }
  }
} 
</style>
